import registry from '../../font_registry.json' with { type: 'json' };

export const STANDARD_FONTS = Object.freeze(registry.fonts.map(item => Object.freeze({...item, source:'standard'})));
const standardById = new Map();
for (const font of STANDARD_FONTS) {
  standardById.set(font.id, font);
  standardById.set(font.family, font);
  for (const alias of font.aliases || []) standardById.set(alias, font);
}
const customById = new Map();
const customObjectUrls = new Map();

export function resolveFont(value) {
  return customById.get(value) || standardById.get(value) || null;
}

export function normalizeFontId(value, fallback) {
  return resolveFont(value)?.id || (value ? String(value) : fallback);
}

export function fontFamily(value, fallback = 'ReelPro Google Sans') {
  return resolveFont(value)?.family || fallback;
}

export function fontWeight(value, preferred = 700) {
  const weight = String(resolveFont(value)?.weight || preferred);
  return weight.includes(' ') ? preferred : Number(weight) || preferred;
}

export async function ensureFontsLoaded(values) {
  const missing = [];
  for (const value of [...new Set(values.filter(Boolean))]) {
    const font = resolveFont(value);
    if (!font) { missing.push(String(value)); continue; }
    try {
      const weight = String(font.weight || '400').includes(' ') ? '400' : String(font.weight || '400');
      const descriptor = `${font.style === 'italic' ? 'italic ' : ''}${weight} 16px "${font.family}"`;
      await document.fonts.load(descriptor);
      if (!document.fonts.check(descriptor)) missing.push(font.label);
    } catch { missing.push(font.label); }
  }
  return missing;
}

export async function registerCustomFont(record) {
  if (!record?.id || !record?.blob) throw new Error('Invalid custom font record.');
  const family = record.family || `ReelPro Custom ${record.id.replace(/[^a-z0-9]/gi,'')}`;
  if (customObjectUrls.has(record.id)) URL.revokeObjectURL(customObjectUrls.get(record.id));
  const url = URL.createObjectURL(record.blob);
  const face = new FontFace(family, `url(${url})`, {weight:String(record.weight || '400'), style:record.style || 'normal'});
  await face.load();
  document.fonts.add(face);
  const normalized = {...record, family, source:'custom'};
  customById.set(record.id, normalized);
  customObjectUrls.set(record.id, url);
  return normalized;
}

export async function registerCustomFonts(records) {
  const loaded = [];
  for (const record of records || []) {
    try { loaded.push(await registerCustomFont(record)); } catch (error) { console.warn(`Could not load ${record?.name || 'custom font'}`, error); }
  }
  return loaded;
}

export function unregisterCustomFont(id) {
  customById.delete(id);
  if (customObjectUrls.has(id)) { URL.revokeObjectURL(customObjectUrls.get(id)); customObjectUrls.delete(id); }
}

export function customFonts() { return [...customById.values()]; }
